import { jsx } from 'react/jsx-runtime';

const ModalRoot = () => {
    return jsx("div", { id: "modal-root", "data-testid": "modal-root" });
};

export { ModalRoot };
